export const Logo = ({ light = false, className = "h-12 md:h-16" }) => (
  <img
    src={light ? "/img/logo_light.png" : "/img/logo_dark.png"}
    alt="Casas com EnCanto"
    className={`${className} w-auto select-none`}
    draggable="false"
  />
);
